import BackButton from "./BackButton";

const stories = {
  name: "BackButton",
  render: () => <BackButton back={() => alert("Go back")} />,
};

export default stories;
